<template>
    <div @click="goOrderDetail">
        <div class="justify-between detail-header">
            <div class="text_7">
                <van-count-down v-if="carDetails.orderState == 2" class="text_7" :time="time"
                    format="剩余 DD天 HH:mm:ss" />
                <span v-else style="color: #999;">
                    支付时间: {{ carDetails.payTime }}
                </span>
            </div>
            <span class="text_9" :style="getFontColor(carDetails.orderStateDesc)">{{ carDetails.orderStateDesc }}</span>
        </div>
        <CarCard :carDetails="carDetails" current="order"></CarCard>
        <div class="justify-between group_9">
            <div class="flex-row group_10">
                <div>
                    <span class="text_17">{{ carDetails.orderState == 2 ? "需" : "已" }}支付定金</span>
                    <span class="text_19">¥</span>
                    <span class="text_21">{{ carDetails.depositPrice }}</span>
                </div>
            </div>
            <div class="flex-row group_11 view_7">
                <div class="flex-col items-center text-wrapper_5 orderBtn" @click.stop="callCustomer">
                    联系专员
                </div>
                <div v-if="carDetails.orderState == 2" class="flex-col items-center text-wrapper_6 orderBtn"
                    @click.stop="goPay">
                    立即支付
                </div>
                <div v-if="carDetails.orderState == 3" class="flex-col items-center text-wrapper_7 orderBtn"
                    @click.stop="goGetCoupon">
                    我的权益
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import CarCard from "./CarCard.vue";
import { CountDown } from "vant";
import "vant/lib/count-down/style";
export default {
    props: ["carDetails"],
    components: { CarCard, CountDown },
    data() {
        return {
            time: 0,
        };
    },
    created() {
        console.log("in CarCardForOrderListVue created");
        console.log(this.carDetails);
        this.time = this.carDetails.lastPayTime - new Date().getTime()
    },
    methods: {
        getFontColor(desc) {
            let obj = {
                "已预订": "#02d644",
                "已成单": "#999",
                "已完结": "#999",
                "已退款": "#999",
            }
            return obj[desc] ? 'color:' + obj[desc] : '';
        },
        callCustomer() {
            console.log("联系专员", this.carDetails.commissionerPhone)
            location.href = 'tel:' + this.carDetails.commissionerPhone
        },
        goOrderDetail() {
            console.log("goOrderDetail in carcardForOrderListVue");
            this.$router.push({
                path: `/salePassat/orderDetail/${this.carDetails.orderId}`,
            });
        },
        goPay() {
            console.log("立即支付", this.carDetails)
            this.$router.push({
                path: "/salePassat/pay",
                query: {
                    orderId: this.carDetails.orderId,
                    from: "orderlist",
                    returnRouter: "/salePassat/orderlist",
                    payAmount: this.carDetails.depositPrice,
                },
            }); //传orderId
        },
        goGetCoupon() {
            console.log(this.carDetails.orderId)
            this.$router.push({ path: `/salePassat/getCoupon/${this.carDetails.orderId}` })
        }
    }
};
</script>
<style lang="scss" scoped>
.group_9 {
    padding: 16px 24px;
    border-top: solid 0.027rem #e0e0e0;

    .group_10 {
        margin: 0.08rem 0;

        .text_17 {
            margin-top: 0.11rem;
            color: #333333;
            font-size: 0.32rem;
            font-family: "PingFang SC";
            line-height: 0.45rem;
        }

        .text_19 {
            margin-left: 0.08rem;
            margin-top: 0.11rem;
            color: #333333;
            font-size: 0.32rem;
            font-family: "PingFang SC";
            line-height: 0.45rem;
        }

        .text_21 {
            color: #333333;
            font-size: 0.43rem;
            font-family: "PingFang SC";
            font-weight: 500;
            line-height: 0.59rem;
        }
    }

    .group_11 {
        padding: 0.13rem 0;
        border-radius: 0.37rem;
        width: 2.08rem;
        height: 0.75rem;
        border: solid 0.013rem #cccccc;

        .text-wrapper_5 {
            // padding: 0.13rem 0;
            border-radius: 0.37rem;
            width: 2.08rem;
            height: 56px;
            line-height: 56px;
            border: solid 0.013rem #cccccc;
            color: #333333;

            .text_23 {
                font-size: 0.32rem;
                font-family: "PingFang SC";
                line-height: 0.45rem;
            }
        }

        .text-wrapper_6 {
            // padding: 0.16rem 0 ;
            background-image: linear-gradient(109.7deg,
                    #ff5933 0%,
                    #ff5933 -20.71%,
                    #ff3000 120.71%,
                    #ff3000 100%);
            margin-left: 0.21rem;
            border-radius: 0.37rem;
            width: 2.08rem;
            height: 56px;
            line-height: 56px;
            color: #ffffff;
        }

        .text-wrapper_7 {
            color: #02D644;
            border: 1px solid #81EAA2;
        }
    }

    .view_7 {
        padding: initial;
        border-radius: initial;
        width: initial;
        height: initial;
        border: initial;
    }
}

.text_7 {
    margin-bottom: 0.08rem;
    color: #ff3000;
    font-size: 0.32rem;
    font-family: "PingFang SC";
    line-height: 0.45rem;
    text-transform: lowercase;
}

.text_9 {
    color: #ff3000;
    font-size: 0.37rem;
    font-family: "PingFang SC";
    font-weight: 500;
    line-height: 0.53rem;
}

.orderBtn {
    margin-left: 0.21rem;
    border-radius: 0.37rem;
    width: 2.08rem;
    height: 56px;
    line-height: 56px;
}

.detail-header {
    padding: 24px 24px 0;
}
</style>



// WEBPACK FOOTER //
// CarCardForOrderList.vue?0bfd5928